import React  from 'react';
import Drawer from 'material-ui/Drawer';
import {spacing, typography} from 'material-ui/styles';
import {blue600, pink600} from 'material-ui/styles/colors';
// import MenuItem from 'material-ui/MenuItem';
import {List, ListItem} from 'material-ui/List';
import {Link, withRouter} from 'react-router-dom';

const LeftDrawer = (props) => {
  let { navDrawerOpen, history , auth} = props;

  const styles = {
    logo: {
      cursor: 'pointer',
      fontSize: 22,
      color: typography.textFullWhite,
      lineHeight: `${spacing.desktopKeylineIncrement}px`,
      fontWeight: typography.fontWeightLight,
      backgroundColor: process.env.REACT_APP_MODE == "dev" ? pink600 : blue600,
      paddingLeft: 40,
      height: 56,
    },
    menuItem: {
      paddingLeft: 10,
      fontSize: 14
    },
  };
  //
  // const systemControllMenu = auth.user.id == 14 ? [
  //     <ListItem
  //         key={1}
  //         style={styles.menuItem}
  //         primaryText="代休操作"
  //         containerElement={<Link to="/systemControll/subHoliday" />}
  //     />,
  //     <ListItem
  //         key={2}
  //         style={styles.menuItem}
  //         primaryText="労務操作"
  //         containerElement={<Link to="/systemControll/roumu" />}
  //     />,
  // ] : [
  //     <ListItem
  //         key={1}
  //         style={styles.menuItem}
  //         primaryText="代休操作"
  //         containerElement={<Link to="/systemControll/subHoliday" />}
  //     />,
  // ]

  const systemControllMenu = [
      <ListItem
          key={1}
          style={styles.menuItem}
          primaryText="代休操作"
          containerElement={<Link to="/systemControll/subHoliday" />}
      />,
      <ListItem
          key={2}
          style={styles.menuItem}
          primaryText="労務集計"
          containerElement={<Link to="/systemControll/roumu" />}
      />,
      <ListItem
          key={3}
          style={styles.menuItem}
          primaryText="労務取得"
          containerElement={<Link to="/systemControll/roumuCsv" />}
      />,
  ]

  // open={navDrawerOpen}>
  return (
    <Drawer
      docked={true}
      open={navDrawerOpen}>
        <div style={styles.logo}>
          {
          }
        </div>

        {auth.user.permission == 2 &&
        <List>
          <ListItem
            key={1}
            style={styles.menuItem}
            primaryText="実行予算管理"
            primaryTogglesNestedList={true}
            nestedItems={
              [
                <ListItem
                  key={1}
                  style={styles.menuItem}
                  primaryText="実行予算一覧"
                  containerElement={<Link to="/yosanList" />}
                />,
                <ListItem
                  key={2}
                  style={styles.menuItem}
                  primaryText="実行予算登録"
                  containerElement={<Link to="/yosan" />}
                />,
              ]
            }
          /> 
          <ListItem
            key={2}
            style={styles.menuItem}
            primaryText="労務管理"
            primaryTogglesNestedList={true}
            nestedItems={
              [
                <ListItem
                  key={1}
                  style={styles.menuItem}
                  primaryText="未承認一覧"
                  containerElement={<Link to="/roumuList" />}
                />,
                <ListItem
                  key={2}
                  style={styles.menuItem}
                  primaryText="労務登録"
                  containerElement={<Link to="/roumu" />}
                />,
                <ListItem
                  key={3}
                  style={styles.menuItem}
                  primaryText="代休登録"
                  containerElement={<Link to="/subHoliday" />}
                />,
                <ListItem
                  key={4}
                  style={styles.menuItem}
                  primaryText="タイムカード"
                  containerElement={<Link to="/timecard" />}
                />,
              ]
            }
          /> 
          <ListItem
            key={3}
            style={styles.menuItem}
            primaryText="残業管理"
            primaryTogglesNestedList={true}
            nestedItems={
              [
                <ListItem
                  key={1}
                  style={styles.menuItem}
                  primaryText="残業申請"
                  containerElement={<Link to="/overTime" />}
                />,
              ]
            }
          /> 
          <ListItem
            key={4}
            style={styles.menuItem}
            primaryText='マスター管理'
            primaryTogglesNestedList={true}
            nestedItems={[
              <ListItem
                key={1}
                style={styles.menuItem}
                primaryText='会社関連'
                primaryTogglesNestedList={true}
                nestedItems={
                  [
                    <ListItem
                      key={1}
                      style={styles.menuItem}
                      primaryText="支店マスタ"
                      containerElement={<Link to="/master/branchOffice" />}
                    />,
                    <ListItem
                      key={2}
                      style={styles.menuItem}
                      primaryText="部署マスタ"
                      containerElement={<Link to="/master/department" />}
                    />, 
                    <ListItem
                      key={3}
                      style={styles.menuItem}
                      primaryText="休日マスタ"
                      containerElement={<Link to="/master/bizHoliday" />}
                    />, 
                  ]
                }

              />,
              <ListItem
                key={2}
                style={styles.menuItem}
                primaryText='件名関連'
                primaryTogglesNestedList={true}
                nestedItems={
                  [
                    <ListItem
                      key={1}
                      style={styles.menuItem}
                      primaryText="件名マスタ"
                      containerElement={<Link to="/master/kenmei" />}
                    /> , 
                    <ListItem
                      key={2}
                      style={styles.menuItem}
                      primaryText="客先マスタ"
                      containerElement={<Link to="/master/customer" />}
                    /> , 
                    <ListItem
                      key={3}
                      style={styles.menuItem}
                      primaryText="工事種別マスタ"
                      containerElement={<Link to="/master/construction" />}
                    /> , 
                    <ListItem
                      key={4}
                      style={styles.menuItem}
                      primaryText="費用マスタ"
                      containerElement={<Link to="/master/cost" />}
                    /> , 
                  ]
                }

              />,

              <ListItem
                key={3}
                style={styles.menuItem}
                primaryText='労務関連'
                primaryTogglesNestedList={true}
                nestedItems={
                  [
                    <ListItem
                      key={1}
                      style={styles.menuItem}
                      primaryText="社員マスタ"
                      containerElement={<Link to="/master/user" />}
                    />,
                    <ListItem
                      key={2}
                      style={styles.menuItem}
                      primaryText="単価マスタ"
                      containerElement={<Link to="/master/price" />}
                    />, 
                    <ListItem
                      key={3}
                      style={styles.menuItem}
                      primaryText="作業マスタ"
                      containerElement={<Link to="/master/work" />}
                    />
                  ]
                }

              />
            ]}
          />
          <ListItem
            key={5}
            style={styles.menuItem}
            primaryText="システム操作"
            primaryTogglesNestedList={true}
            nestedItems={systemControllMenu}
          />
          <ListItem
            key={6}
            style={styles.menuItem}
            primaryText="パスワード更新"
            containerElement={<Link to="/password" />}
          />

        </List>
        }




        {auth.user.permission == 1 &&
        <List>
          <ListItem
            key={1}
            style={styles.menuItem}
            primaryText="実行予算管理"
            primaryTogglesNestedList={true}
            nestedItems={
              [
                <ListItem
                  key={1}
                  style={styles.menuItem}
                  primaryText="実行予算一覧"
                  containerElement={<Link to="/yosanList" />}
                />,
                <ListItem
                  key={2}
                  style={styles.menuItem}
                  primaryText="実行予算登録"
                  containerElement={<Link to="/yosan" />}
                />,
              ]
            }
          /> 
          <ListItem
            key={2}
            style={styles.menuItem}
            primaryText="労務管理"
            primaryTogglesNestedList={true}
            nestedItems={
              [
                <ListItem
                  key={2}
                  style={styles.menuItem}
                  primaryText="労務登録"
                  containerElement={<Link to="/roumu" />}
                />,
                <ListItem
                key={3}
                style={styles.menuItem}
                primaryText="代休登録"
                containerElement={<Link to="/subHoliday" />}
                />,
                <ListItem
                  key={4}
                  style={styles.menuItem}
                  primaryText="タイムカード"
                  containerElement={<Link to="/timecard" />}
                />,
              ]
            }
          />          
          <ListItem
            key={3}
            style={styles.menuItem}
            primaryText="残業管理"
            primaryTogglesNestedList={true}
            nestedItems={
              [
                <ListItem
                  key={1}
                  style={styles.menuItem}
                  primaryText="残業申請"
                  containerElement={<Link to="/overTime" />}
                />,
              ]
            }
          />  
          <ListItem
            key={4}
            style={styles.menuItem}
            primaryText='マスター管理'
            primaryTogglesNestedList={true}
            nestedItems={[
              <ListItem
                key={2}
                style={styles.menuItem}
                primaryText='件名関連'
                primaryTogglesNestedList={true}
                nestedItems={
                  [
                    <ListItem
                      key={1}
                      style={styles.menuItem}
                      primaryText="件名マスタ"
                      containerElement={<Link to="/master/kenmei" />}
                    /> , 
                  ]
                }

              />,

            ]}
          />

          <ListItem
            key={5}
            style={styles.menuItem}
            primaryText="パスワード更新"
            containerElement={<Link to="/password" />}
          />

        </List>
        }

        {auth.user.permission == 3 &&
        <List>
            <ListItem
                key={1}
                style={styles.menuItem}
                primaryText="実行予算管理"
                primaryTogglesNestedList={true}
                nestedItems={
                    [
                        <ListItem
                            key={1}
                            style={styles.menuItem}
                            primaryText="実行予算一覧"
                            containerElement={<Link to="/yosanList" />}
                        />,
                        <ListItem
                            key={2}
                            style={styles.menuItem}
                            primaryText="実行予算登録"
                            containerElement={<Link to="/yosan" />}
                        />,
                    ]
                }
            />
            <ListItem
                key={2}
                style={styles.menuItem}
                primaryText="労務管理"
                primaryTogglesNestedList={true}
                nestedItems={
                    [
                        <ListItem
                            key={1}
                            style={styles.menuItem}
                            primaryText="未承認一覧"
                            containerElement={<Link to="/roumuList" />}
                        />,
                        <ListItem
                            key={2}
                            style={styles.menuItem}
                            primaryText="労務登録"
                            containerElement={<Link to="/roumu" />}
                        />,
                        <ListItem
                            key={3}
                            style={styles.menuItem}
                            primaryText="代休登録"
                            containerElement={<Link to="/subHoliday" />}
                        />,
                        <ListItem
                            key={4}
                            style={styles.menuItem}
                            primaryText="タイムカード"
                            containerElement={<Link to="/timecard" />}
                        />,
                    ]
                }
            />
            <ListItem
                key={3}
                style={styles.menuItem}
                primaryText="残業管理"
                primaryTogglesNestedList={true}
                nestedItems={
                    [
                        <ListItem
                            key={1}
                            style={styles.menuItem}
                            primaryText="残業申請"
                            containerElement={<Link to="/overTime" />}
                        />,
                    ]
                }
            />
            <ListItem
                key={4}
                style={styles.menuItem}
                primaryText='マスター管理'
                primaryTogglesNestedList={true}
                nestedItems={[
                    <ListItem
                        key={2}
                        style={styles.menuItem}
                        primaryText='件名関連'
                        primaryTogglesNestedList={true}
                        nestedItems={
                            [
                                <ListItem
                                    key={1}
                                    style={styles.menuItem}
                                    primaryText="件名マスタ"
                                    containerElement={<Link to="/master/kenmei" />}
                                /> ,
                            ]
                        }

                    />,

                ]}
            />

            <ListItem
                key={5}
                style={styles.menuItem}
                primaryText="パスワード更新"
                containerElement={<Link to="/password" />}
            />

        </List>
        }

    </Drawer>
  );
};

export default withRouter(LeftDrawer);



// WEBPACK FOOTER //
// ./src/components/LeftDrawer.js